import React, { useState, useEffect, useContext } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import { ContentLoader, NoRecords } from "../../Components/Shimmer";
import Select from "react-select";
import { NavLink } from "react-router-dom";
import 'flatpickr/dist/themes/material_blue.css';
import { DateFormaterMonth, formatDateRange } from "../../Components/GlobalFunctions";
import { handleDownloadOptions } from "../../Components/ExportData";
const InspectionRequest = () => {

    const { apiURL, apiHeaderJson, user_profile_id } = useContext(ConfigContext);
    const [inspectionRequestData, setInspectionRequestData] = useState([]);
    const [next, setNext] = useState(false);
    const [prev, setPrev] = useState(false);
    const [page, setPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loadingList, setLoadingList] = useState(false);
    const [keyword, setKeyword] = useState("");
    const [reload, setReload] = useState(false)
    const [selectOption, setSelectOption] = useState(null);
    const [inspectionFormData, setInspectionFormData] = useState([]);
    const [inspectionFormID, setinspectionFormID] = useState(0)
    const [projectListData, setProjectListData] = useState([])
    const [projectId, setProjectId] = useState(0);
    const [consultantData, setConsultantData] = useState([]);
    const [consultantId, setConsultantId] = useState(0)




    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "keyword") {
            setKeyword(value);
        }
    };

    const handleFilter = () => {
        setPage(1);
        setReload(true);
    }

    const resetForm = async () => {
        setinspectionFormID(0);
        setProjectId(0)
        setConsultantId(0)
    }

    const GetList = async () => {
        setLoadingList(true);
        try {
            const headers = apiHeaderJson;
            const response = await axios
                .get(`${apiURL}api/inspections/GetInspectionsByContractor`, { params: { contractor_id: user_profile_id }, headers })
            const data = response.data;
            console.log(data, "Dataaaaa")
            if (data.success) {
                setInspectionRequestData(data.data);
                setNext(data.next);
                setPrev(data.prev);
                setPage(data.page);
                setTotalRecords(data.total_records);
                setTotalPages(data.total_pages);
                setReload(false);
            }

        } catch (error) {
            console.log(error);

        } finally {
            setLoadingList(false);
        }
    };

    const getInspectionForm = async () => {
        try {
            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}api/inspections/GetInspections`, { headers })
            const { data, success } = response.data;
            setInspectionFormData(
                data.map((row) => ({
                    value: row.inspection_id,
                    label: row.inspection_title
                }))
            )
        } catch (error) {
            console.log(error);

        }
    }

    const GetProjectList = async () => {
        try {
            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}api/contractors/projects/${user_profile_id}`, { headers })
            const { data, success } = response.data;
            if (success === true) {
                setProjectListData(
                    data.map((row) => ({
                        value: row.project_id,
                        label: row.project_title
                    }))
                )
            }
        } catch (error) {
            console.log(error);

        }
    }

    const getProjectConsultant = async () => {
        try {
            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}api/project-consultants/project/${projectId}`)
            const { data, success } = response.data;
            if (success === true) {
                setConsultantData(
                    data.map((row) => ({
                        value: row.consultant_id,
                        label: row.profile_name
                    }))
                )
            }

        } catch (error) {
            console.log(error);

        }
    }

    const CancelRequest = async (inspectionID) => {
        try {
            const headers = apiHeaderJson;
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, cancel it!",
            });

            if (result.isConfirmed) {
                const response = await axios.post(`${apiURL}api/inspections/CancelInspectionRequest`, { project_inspection_id: inspectionID, contractor_id: user_profile_id });
                const { success, message } = response.data
                await Swal.fire({
                    title: `${success ? "Success" : "Failed"}`,
                    text: message,
                    icon: success ? "success" : "error",
                    timer: 1000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                });

                if (response.data.success) {
                    setLoadingList(false);
                    GetList();
                }
            }
        } catch (error) {
            await Swal.fire({
                title: "<strong>Error</strong>",
                html: error.message || "Something went wrong!",
                icon: "error",
            });
        }
    };


    const handleSubmit = async () => {
        try {
            const Body = {
                inspection_id: inspectionFormID,
                contractor_id: user_profile_id,
                project_id: projectId,
                consultant_id: consultantId
            }
            const headers = apiHeaderJson;
            const response = await axios.post(`${apiURL}api/inspections/RequestProjectInspection`, Body, { headers })
            const { success, message } = response.data;
            if (success == true) {
                await Swal.fire({
                    title: `${success ? "Success" : "Failed"}`,
                    text: message,
                    icon: response.data.success ? "success" : "error",
                    timer: 1000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                });
                GetList();
                resetForm()
                document.getElementById("close-inspection-modal").click();
            }


        } catch (error) {
            console.log(error);
            await Swal.fire({
                title: "Error",
                html: error.message || "Something went wrong!",
                icon: "error",
            });

        }
    }

    const handlePrev = () => {
        if (prev) {
            setPage((prevPage) => prevPage - 1);
        }
    };

    const handleNext = () => {
        if (next) {
            setPage((prevPage) => prevPage + 1);
        }
    };

    const handleChange = (e) => {
        setPage(parseInt(e.target.value, 10));
    };


    const handleClear = () => {
        setKeyword("")
        setReload(true);
    }

    const handleDownload = (downloadType) => {
        const endpoint = `api/inspections/GetInspectionsByContractor`;
        const params = { contractor_id: user_profile_id }

        const columns = [
            { header: "Project Name", width: 35 },
            { header: "Project Location", width: 20 },
            { header: "Consultant Name", width: 26 },
            { header: "	Inspection Request Date", width: 20 },
            { header: "Project Status", width: 25 },
        ];


        const mapRow = (data) => {

            return {
                "Project Name": data?.project_title ?? "-",
                "Project Location": data?.project_address ?? "-",
                "Consultant Name": data?.profile_name ?? "-",
                "	Inspection Request Date": DateFormaterMonth(data.inspection_request_date) ?? "-",
                "Project Status": getStatus(data.inspection_request_status) ?? "-",
            };

        };


        handleDownloadOptions(endpoint, params, columns, mapRow, downloadType, apiURL, apiHeaderJson);
    };
    const getStatus = (status) => {
        if (status === "0") {
            return "Pending"
        }
        if (status === "1") {
            return "Approved"
        }
        if (status === "2") {
            return "Rejected"
        }
    }
    const getBadge = (status) => {
        if (status === "0") {
            return "badge bg-warning-subtle text-warning"
        }
        if (status === "2") {
            return "badge bg-danger-subtle text-danger"
        }
        if (status === "1") {
            return "badge bg-success-subtle text-success"
        }
    }
    const options = [
        { value: 'completed', label: 'Completed' },
        { value: 'pending', label: 'Pending' },
        { value: 'assigned', label: "Assigned" }
    ];

    const handleSelect = (selectedOption) => {
        setinspectionFormID(selectedOption ? selectedOption.value : null)
    }

    const handleProjectSelect = (selectOption) => {
        setProjectId(selectOption ? selectOption.value : null)
    }

    const handleConsuntantSelect = (selectOption) => {
        setConsultantId(selectOption ? selectOption.value : null)
    }

    const handleSelectStatus = (selectedOption) => {
        setSelectOption(selectedOption ? selectedOption.value : '');
    };



    // useEffect(() => {
    //   reload && GetList()
    // }, [reload])
    useEffect(() => {
        GetList();
        getInspectionForm()
        GetProjectList()

    }, []);
    useEffect(() => {
        projectId && getProjectConsultant()
    }, [projectId])
    return (
        <div className="main-content">
            <div className="page-content">
                {loadingList === false ? (
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Inspection Request list`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">

                                    <div
                                        className='card-header align-items-center d-flex'
                                        style={{
                                            background: "#257180",
                                        }}>
                                        <h4 className='card-title mb-0 flex-grow-1 text-white'>Inspection Request List</h4>

                                        <div className="d-flex align-items-center gap-3">


                                            <button
                                                type="button"
                                                data-bs-toggle="modal"
                                                data-bs-target="#InspectionModal"
                                                className="btn btn-warning btn-label waves-effect waves-light"
                                            >
                                                <i className="ri-add-circle-line label-icon align-middle fs-16 me-2" />
                                                Add Inspection Request
                                            </button>


                                        </div>
                                    </div>
                                    <div className="card-header pt-0 pb-0" style={{ border: "none" }}>
                                        <div className="row py-4 pb-2 mb-3">
                                            <div className="col-md-3">

                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="keyword"
                                                        aria-label="Recipient's username"
                                                        aria-describedby="button-addon2"
                                                        placeholder="Please Enter Keyword"
                                                        value={keyword}
                                                        onChange={handleInputChange}
                                                    />

                                                    <span
                                                        className='mdi mdi-magnify search-widget-icon'
                                                        style={{
                                                            position: "absolute",
                                                            right: "10px",
                                                            top: "50%",
                                                            transform: "translateY(-50%)",
                                                            fontSize: "3.5vh",
                                                            color: "#B1B1B6",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <Select
                                                    options={options} // Pass the options array
                                                    value={selectOption ? options.find(option => option.value === selectOption) : null}
                                                    onChange={handleSelectStatus}

                                                    placeholder="Please Select Status"
                                                />
                                            </div>
                                            <div className="col-md-3"></div>
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-3">


                                                    </div>
                                                    <div className="col-md-9">

                                                        <div className="dropdown">
                                                            <button type="button" className="btn btn-light btn-label waves-effect waves-light " id="dropdownMenuLink4" data-bs-toggle="dropdown" aria-expanded="true"
                                                            >
                                                                <i className="ri-download-2-line label-icon align-middle fs-16 me-2" />
                                                                Download Report
                                                            </button>
                                                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink4">
                                                                <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('print')}><i className="ri-printer-line me-2 align-middle text-muted" />Print</a>
                                                                </li>
                                                                <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('pdf')}><i className="ri-file-pdf-line me-2 align-middle text-muted" />PDF</a>
                                                                    <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('excel')}><i className="ri-file-excel-2-line me-2 align-middle text-muted" />Excel</a>
                                                                    </li>

                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body pt-0">
                                        <table
                                            className={`table table-bordered table-stripped`}
                                        >
                                            <thead className="table-light">
                                                <tr>
                                                    <th className="text-center" width={220}>Project Name</th>
                                                    <th className="text-center">Location</th>
                                                    <th className="text-center" width={160}>Consultant Name</th>
                                                    <th className="text-center" width={181}>Inspection Request Date</th>
                                                    <th className="text-center" width={122}>Request Status</th>
                                                    <th className="text-center" width={40}>Action</th>
                                                </tr>
                                            </thead>
                                            {inspectionRequestData.length !== 0 ? (
                                                <tbody>
                                                    {inspectionRequestData.map((row, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center">
                                                                <NavLink to={`/ProjectProfile/${row.project_id}`}>{row?.project_title}</NavLink>
                                                            </td>
                                                            <td className="text-center">{row.project_address}</td>
                                                            <td className="text-center">{row.profile_name}</td>
                                                            <td className="text-center">{DateFormaterMonth(row.inspection_request_date)}</td>
                                                            <td className="text-center"><span className={getBadge(row.inspection_request_status)}>{getStatus(row.inspection_request_status)}</span></td>
                                                            {
                                                                row.inspection_request_status === "1" ? "" :
                                                                    <td className="d-flex justify-content-around">
                                                                        <button
                                                                            onClick={() => CancelRequest(row.project_inspection_id)}
                                                                            type="button"
                                                                            className="btn-icon btn btn-sm btn-outline-secondary "
                                                                        >
                                                                            <i className="ri-close-line"></i>
                                                                        </button>
                                                                    </td>
                                                            }
                                                        </tr>
                                                    ))}
                                                </tbody>

                                            ) : (
                                                <tbody>
                                                    <tr>
                                                        <td colSpan="8">
                                                            <NoRecords />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            )}
                                            <tfoot className="table-light">
                                                <tr>
                                                    <th colSpan={8}>
                                                        <div className="d-flex justify-content-between">
                                                            <button
                                                                disabled={
                                                                    prev === false && loadingList === false
                                                                        ? true
                                                                        : false
                                                                }
                                                                type="button"
                                                                onClick={() => handlePrev()}
                                                                className={`btn btn-warning btn-label waves-effect waves-light`}
                                                            >
                                                                <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                                                                Previous
                                                            </button>
                                                            <div
                                                                className="col-md-4"
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                {
                                                                    <small>
                                                                        Total Records: {totalRecords} | Total
                                                                        Pages: {totalPages} | Current Page:{" "}
                                                                        {page}
                                                                    </small>
                                                                }
                                                            </div>
                                                            <div className="col-md-2">
                                                                <select
                                                                    className="form-select"
                                                                    onChange={(e) => handleChange(e)}
                                                                >
                                                                    {Array.from(
                                                                        { length: totalPages },
                                                                        (_, i) => (
                                                                            <option
                                                                                key={i + 1}
                                                                                selected={page === i + 1}
                                                                                value={i + 1}
                                                                            >
                                                                                {i + 1}
                                                                            </option>
                                                                        )
                                                                    )}
                                                                </select>
                                                            </div>
                                                            <button
                                                                disabled={
                                                                    next === false && loadingList === false
                                                                        ? true
                                                                        : false
                                                                }
                                                                type="button"
                                                                onClick={() => handleNext()}
                                                                className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                            >
                                                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                                                                Next
                                                            </button>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                ) : (
                    <ContentLoader />
                )}
            </div>
            <div
                id="InspectionModal"
                className="modal fade"
                tabIndex={-1}
                aria-labelledby="myModalLabel"
                aria-hidden="true"
                style={{ display: "none" }}
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="myModalLabel">
                                Request For Inspection
                            </h5>
                            <button
                                type="button"
                                id="close-inspection-modal"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => resetForm()}
                            >
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="">
                                    <div className=" shadow-none">
                                        <div className="card-body">
                                            <div className="row gy-4">
                                                <div className="col-md-12">
                                                    <form className="row">
                                                        <div className="col-md-12 mt-0 ">
                                                            <Select
                                                                onChange={handleSelect}
                                                                options={inspectionFormData}
                                                                placeholder="Please Select Inspection Form"
                                                                value={inspectionFormID ? inspectionFormData.find((options) => options.value === inspectionFormID) : null}
                                                            />
                                                        </div>
                                                        <div className="col-md-12 mt-3">
                                                            <Select
                                                                onChange={handleProjectSelect}
                                                                options={projectListData}
                                                                placeholder="Please Select Project"
                                                                value={projectId ? projectListData.find((option) => option.value === projectId) : null}
                                                            />
                                                        </div>

                                                        <div className="col-md-12 mt-3">
                                                            <Select
                                                                onChange={handleConsuntantSelect}
                                                                placeholder='Please Select Consultant'
                                                                options={consultantData}
                                                                value={consultantId ? consultantData.find((options) => options.value) : null}
                                                            />
                                                        </div>

                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light"
                                data-bs-dismiss="modal"
                                onClick={() => resetForm()}
                            >
                                Close
                            </button>
                            <button type="submit" className="btn btn-primary "
                                onClick={handleSubmit}
                                disabled={!inspectionFormID || !projectId || !consultantId}
                            >
                                Submit Request
                                <i className="ri-save-line label-icon align-middle fs-16 ms-2"></i>

                            </button>
                        </div>
                    </div>
                    {/* /.modal-content */}
                </div>
                {/* /.modal-dialog */}
            </div>
        </div >

    );
};

export default InspectionRequest